import { PencilStrokeFillIcon } from "@lifesg/react-icons/pencil-stroke-fill"; //import { FaEdit } from "react-icons/fa";

export const EditIcon = (props: any): JSX.Element => (
	<div {...props}>
		<PencilStrokeFillIcon className="button-icon-edit" />
	</div>
);
